import script from "./BucketDelete.vue?vue&type=script&lang=ts&setup=true"
export * from "./BucketDelete.vue?vue&type=script&lang=ts&setup=true"

import "./BucketDelete.vue?vue&type=style&index=0&id=445dd28b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-445dd28b"]])

export default __exports__